import { useEffect, useState } from "react";
import { useParams, useSearchParams, Navigate } from "react-router-dom";
import { api } from "../lib/api";
import Barcode from "react-barcode";
import { Printer, X } from "lucide-react";

export default function BarcodeLabelPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const copies = parseInt(searchParams.get("copies")) || 12;
  const [part, setPart] = useState(null);
  const [err, setErr] = useState("");
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("kk_token")) { setAuthed(false); return; }
    api.get("/auth/me").then(() => setAuthed(true)).catch(() => setAuthed(false));
  }, []);

  useEffect(() => {
    if (!authed) return;
    api.get(`/admin/parts`).then((r) => {
      const p = r.data.find((x) => x.id === id);
      if (p) {
        setPart(p);
        setTimeout(() => window.print(), 700);
      } else {
        setErr(`Piesa cu id ${id?.slice(0, 8)} nu a fost gasita in baza de date.`);
      }
    }).catch((e) => setErr(e.response?.data?.detail || "Eroare la conectarea cu serverul"));
  }, [id, authed]);

  if (authed === false) return <Navigate to="/admin/login" replace />;
  if (authed === null) return <div className="p-10 text-center text-neutral-500">Verificare autentificare...</div>;
  if (err) return (
    <div className="p-10 text-center max-w-lg mx-auto">
      <div className="text-2xl font-bold mb-3">Piesa inexistenta</div>
      <p className="text-sm text-neutral-600 mb-6">{err}</p>
      <button onClick={() => window.close()} className="bg-[#00E5FF] text-black px-5 py-2 uppercase text-sm font-semibold">Inchide</button>
    </div>
  );
  if (!part) return <div className="p-10 text-center text-neutral-500">Se incarca piesa...</div>;

  return (
    <div className="bg-white text-black min-h-screen">
      <style>{`
        @page { size: A4; margin: 8mm; }
        @media print { .no-print { display: none !important; } body { background: white !important; } }
        .kk-labels { font-family: 'Outfit', sans-serif; }
      `}</style>

      <div className="no-print fixed top-4 right-4 flex gap-2 z-50">
        <button onClick={() => window.print()} className="bg-[#00E5FF] text-black font-semibold px-4 py-2 text-sm uppercase tracking-wider">
          <Printer className="w-4 h-4 inline mr-1" /> Printeaza
        </button>
        <button onClick={() => window.close()} className="border border-neutral-400 text-neutral-700 px-4 py-2 text-sm uppercase tracking-wider">
          <X className="w-4 h-4 inline mr-1" /> Inchide
        </button>
        <select onChange={(e) => { window.location.search = `?copies=${e.target.value}`; }} value={copies} className="border border-neutral-400 px-2 text-sm">
          <option value="4">4 etichete/foaie</option>
          <option value="12">12 etichete/foaie</option>
          <option value="24">24 etichete/foaie</option>
          <option value="40">40 etichete/foaie</option>
        </select>
      </div>

      <div className="kk-labels p-6">
        <div className="text-center mb-4 text-xs uppercase tracking-widest text-neutral-500 no-print">
          Decupezi si lipesti pe piese
        </div>
        <div className={`grid gap-2 ${copies <= 4 ? "grid-cols-2" : copies <= 12 ? "grid-cols-3" : copies <= 24 ? "grid-cols-4" : "grid-cols-5"}`}>
          {Array.from({ length: copies }).map((_, i) => (
            <div key={i} className="border border-dashed border-neutral-400 p-2 flex flex-col items-center justify-center text-center" style={{ pageBreakInside: "avoid" }}>
              <div className="text-[8px] font-bold text-[#00E5FF] uppercase tracking-widest mb-1">KUKIRIN SERVICE</div>
              <div className="text-[10px] font-bold leading-tight mb-1 line-clamp-2">{part.name}</div>
              <Barcode value={part.sku} format="CODE128" width={1.5} height={36} fontSize={10} margin={0} background="#ffffff" lineColor="#000000" />
              {part.price > 0 && <div className="text-[10px] mt-1">{part.price} RON</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
